<template>
  <v-footer
    class="py-4"
    dark
    height="auto"
  >
    <v-container class="mx-auto">
      <v-row>
        <v-col cols="9">
          <base-btn
            v-for="(item, i) in items"
            :key="i"
            :href="item.href"
            class="ml-0 mr-3"
            color="primary"
            square
            target="_blank"
          >
            <v-icon v-text="item.icon" />
          </base-btn>
        </v-col>

        <v-spacer />

        <base-btn
          class="mr-0"
          square
          title="Go to top"
          @click="$vuetify.goTo(0)"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </base-btn>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <span>contact@xterra.group</span> <br>
          <span> +48 690 12 34 12 <span style="color:#cbaa5c"><b>|</b></span> ul. Heweliusza 5b/22 <span style="color:#cbaa5c"><b>|</b></span> 60-281 Poznań</span> <br>
          <span> +48 782 51 98 07 <span style="color:#cbaa5c"><b>|</b></span> ul. Kruszyńska 30b <span style="color:#cbaa5c"><b>|</b></span> 01-365 Warszawa</span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'CoreFooter',

    data: () => ({
      items: [
        {
          href: 'https://www.instagram.com/xterra_wood/',
          icon: 'mdi-instagram',
        },
        {
          href: 'https://www.facebook.com/Xterra-Carport-108118188288829',
          icon: 'mdi-facebook',
        },
        {
          href: 'https://pl.pinterest.com/sawickitomasz/xterra-wood-houses/',
          icon: 'mdi-pinterest',
        }
      ],
    }),
  }
</script>
